export default "__VITE_ASSET__Drut1jMn__"